import { useCallback, useEffect } from 'react';

/**
 * Use this to hook into the browser's "beforeunload" event
 * in order to warn the user that their unsaved data might
 * get lost if they leave.
 */
export function useWarnUserBeforeLeaving(shouldWarnUser: boolean) {
  /**
   * Before unload handler which warns the user before leaving.
   * See https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#examples
   */
  const eventListener = useCallback((e: BeforeUnloadEvent) => {
    e.preventDefault();
    return (e.returnValue = 'Test');
  }, []);
  useEffect(() => {
    if (shouldWarnUser) {
      window.addEventListener('beforeunload', eventListener, { capture: true });
    } else {
      window.removeEventListener('beforeunload', eventListener, {
        capture: true,
      });
    }
    return () => {
      window.removeEventListener('beforeunload', eventListener, {
        capture: true,
      });
    };
  }, [shouldWarnUser]);
}
